<template>
  <div class="staffs-setting">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'StaffsSetting'
}
</script>

<style lang="scss" scoped>
.staffs-setting {
  width: 100%;
  min-width: 614px;
  text-align: left;
}
</style>
